module.exports = __webpack_public_path__ + "static/media/ekko.2419a3e8.png";